const getDefaultState = () => ({
  countries: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  areas: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/twenty/defaultState.js